<template>
	<LayoutBase>
		<header id="content__header">
			<img
                v-if="resource.avatar"
                class="avatar"
                :src="`/images/avatar/${resource.id}`"
                :alt="`Avatar for ${resource.name}`"
            />

			<div class="user-name">
				<h1>{{ resource.name }}</h1>
				<h3>{{ resource.member.name }}</h3>
			</div>

			<router-link :to="{ name: 'edit-user', params: { user_id: resource.id } }" class="btn btn--primary" v-if="resource.can.edit">
				Edit
			</router-link>

			<ul class="grid post-details">
				<li v-if="resource.phone" class="col-12 col-md-4 col-xlg-3 col-md-bleed-y detail">
					<span class="label">Telephone</span>
					<a :href="'tel:' + resource.phone"><SvgIcon :icon="'phone'" />{{ resource.phone }}</a>
				</li>
				<li v-if="resource.email" class="col-12 col-md-4 col-xlg-3 col-md-bleed-y detail">
					<span class="label">Email</span>
					<a :href="'mailto:' + resource.email" target="_blank"><SvgIcon :icon="'email'" />{{ resource.email }}</a>
				</li>
				<li v-if="resource.languages" class="col-12 col-md-4 col-xlg-3 col-md-bleed-y detail">
					<span class="label">Languages</span>
					<h3><SvgIcon :icon="'language'" /> {{ resource.languages }}</h3>
				</li>
				<li v-if="resource.office && resource.office.location" class="col-12 col-md-4 col-xlg-3 col-md-bleed-y detail">
					<span class="label">Location</span>
					<h3><SvgIcon :icon="'location'" /> {{ resource.office.location }}</h3>
				</li>
				<li v-if="resource.position" class="col-12 col-md-4 col-xlg-3 col-md-bleed-y detail">
					<span class="label">Position</span>
					<h3><SvgIcon :icon="'position'" /> {{ resource.position}}</h3>
				</li>
				<li v-if="resource.specialisms" class="col-12 detail">
					<span class="label">Sectors expertise</span>
					<span class="sector" v-for="specialism in resource.specialisms">{{ specialism.name }}</span>
				</li>
			</ul>
		</header>

		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="background" title="Background">
				<div class="grid">
					<div class="col-12 col-md-8">
						<div class="card" v-if="resource.background">
							<h4 class="header">Background</h4>
							{{ resource.background }}
						</div>
						<div class="card" v-if="resource.expertise">
							<h4 class="header">Expertise</h4>
							{{ resource.expertise }}
						</div>
						<div class="card" v-if="resource.career">
							<h4 class="header">Career</h4>
							{{ resource.career }}
						</div>
					</div>
					<div class="col-12 col-md-4">
						<router-link :to="{ name: 'view-member', params: { id: resource.member.id }}" class="card card--image">
							<img
                                :src="`/images/logo/${resource.member.id}`"
                                :alt="`Logo for ${resource.member.name}`"
                            />
						</router-link>
					</div>
				</div>
			</v-tab>

			<v-tab id="opportunities" title="Opportunities">
				<div class="toolbar">
					<fieldset class="toolbar__filters">
						<div class="flex-fix">
							<FormControlSector
                                name="sectors"
                                v-model="oppFilters.sectors"
                                :multiple="true"
                                :include-ancestors="false"
                            />
							<FormControlDealType
                                name="dealType"
                                v-model="oppFilters.dealType"
                            />
						</div>
					</fieldset>
					<fieldset class="toolbar__search">
						<div class="flex-fix">
							<div class="form__group search">
								<label for="opp-search" class="form__label">Search Opportunities</label>
								<input
                                    id="opp-search"
                                    class="form__control search"
                                    type="search"
                                    placeholder="Search Opportunities..."
                                    v-model="oppFilters.query"
                                />
							</div>
						</div>
					</fieldset>
				</div>
				<ListOpportunities
                    ref="opportunities"
                    :load-on-start="false"
                    :filters="oppFilters"
                />
			</v-tab>

			<v-tab id="madds" title="MADDs">
				<div class="toolbar">
					<fieldset class="toolbar__filters">
						<div class="flex-fix">
							<FormControlSector
                                name="sectors"
                                v-model="maddFilters.sectors"
                                :multiple="true"
                                :include-ancestors="false"
                            />
							<FormControlDealType
                                name="dealType"
                                v-model="maddFilters.dealType"
                            />
						</div>
					</fieldset>
					<fieldset class="toolbar__search">
						<div class="flex-fix">
							<div class="form__group search">
								<label for="madd-search" class="form__label">Search MADDs</label>
								<input
                                    id="madd-search"
                                    class="form__control search"
                                    type="search"
                                    placeholder="Search MADDs..."
                                    v-model="maddFilters.query"
                                />
							</div>
						</div>
					</fieldset>
				</div>
				<ListMADDs
                    ref="madds"
                    :load-on-start="false"
                    :filters="maddFilters"
                />
			</v-tab>

			<v-tab id="intelligence" title="Intelligence">
				<div class="toolbar">
					<fieldset class="toolbar__filters">
						<div class="flex-fix">
							<FormControlSector
                                name="sectors"
                                v-model="intFilters.sectors"
                                :multiple="true"
                                :include-ancestors="false"
                            />
							<FormControlDealType
                                name="dealType"
                                v-model="intFilters.dealType"
                            />
						</div>
					</fieldset>
					<fieldset class="toolbar__search">
						<div class="flex-fix">
							<div class="form__group search">
								<label for="int-search" class="form__label">Search Intelligence</label>
								<input
                                    id="int-search"
                                    class="form__control search"
                                    type="search"
                                    placeholder="Search Intelligence..."
                                    v-model="intFilters.query"
                                />
							</div>
						</div>
					</fieldset>
				</div>
				<ListIntelligence
                    ref="intelligence"
                    :load-on-start="false"
                    :filters="intFilters"
                />
			</v-tab>

<!--			<v-tab id="insights" title="Insights">-->
<!--				<div class="toolbar">-->
<!--					<fieldset class="toolbar__filters">-->
<!--						<div class="flex-fix">-->
<!--							<FormControlSector name="sectors" v-model="insFilters.sectors" :multiple="true" :include-ancestors="false"></FormControlSector>-->
<!--						</div>-->
<!--					</fieldset>-->
<!--					<fieldset class="toolbar__search">-->
<!--						<div class="flex-fix">-->
<!--							<div class="form__group search">-->
<!--								<label for="insight-search" class="form__label">Search Insights</label>-->
<!--								<input id="insight-search" class="form__control search" type="search" placeholder="Search Insights..." v-model="insFilters.query" />-->
<!--							</div>-->
<!--						</div>-->
<!--					</fieldset>-->
<!--				</div>-->
<!--				<ListInsights ref="insights" :load-on-start="false" :filters="insFilters"></ListInsights>-->
<!--			</v-tab>-->
		</vue-tabs>
	</LayoutBase>
</template>

<script>
	import LayoutBase from '../Layout/LayoutBase';
	import API from './../../api';
	import SvgIcon from '../SvgIcon';
	import FormControlDealType from './../Form/Control/FormControlDealType';
	import FormControlSector from './../Form/Control/FormControlSector';

	import ListOpportunities from './../List/ListOpportunities';
	import ListMADDs from './../List/ListMADDs';
	import ListIntelligence from './../List/ListIntelligence';
	import ListInsights from './../List/ListInsights';
	import TabbedPage from '../TabbedPage';
	import ResourceView from '../ResourceView';

	export default {
		name: 'UserView',
		mixins: [TabbedPage, ResourceView],
		components: {
			SvgIcon,
			LayoutBase,
			ListOpportunities,
			FormControlDealType,
			FormControlSector,
			ListMADDs,
			ListIntelligence,
			ListInsights
		},
		data() {
			return {
				resource: {
					firstName: ' ',
					phone: ' ',
					email: ' ',
					languages: ' ',
					avatar: {
						url : '//placehold.it/60x60'
					},
					location: {
						name: '',
					},
					member: {
						name: '',
						logo:{
							url: '',
						}
					}
				},
				oppFilters: {
					sectors: null,
					dealType: null,
					query: null,
					creator_id: this.id,
				},
				maddFilters: {
					sectors: [],
					dealType: null,
					creator_id: this.id,
					query: null,
				},
				intFilters: {
					sectors: [],
					dealType: null,
					creator_id: this.id,
					query: null,
				},
				insFilters: {
					sectors: [],
					dealType: null,
					creator_id: this.id,
					query: null,
				},
				defaultTab: 'background',
				tabRoute: 'view-user',
			}
		},
        watch: {
            id: function (newVal, oldVal) {
                return API.getUser(newVal).then(response => {
                    console.log("[UserView.vue] - ", response);
                    this.resource = response;
                });
            }
        },
		methods: {
			fetchResource() {
				return API.getUser(this.id);
			},
		}
	}
</script>
<style lang="scss" scoped>
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';

	#content__header{
		align-items: center;

		.user-name{
			display: flex;
			align-items: baseline;
			margin-left: 1.5rem;

			h1, h3{
				margin-bottom: 0;
			}

			h3{
				margin-left: 1rem;
				color: $text;
				@include respond-to(medium){
					margin-left: 0;
				}
			}

			@include respond-to(medium){
				display: block;
			}
		}

		.btn {
			margin-left: auto;
		}
	}

	.card + .card {
		margin-top: 2rem;
	}
</style>
